// @flow

import React, { Component } from 'react';

import { Questions } from '../../assets/model';

import type answer from './_QuestionHandler';

type Props = {};

type State = {};

class Success extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <div className="">Ihre Daten wurden erfolgreich übermittelt.</div>

        <div className="bottomBar">
          <div onClick={() => {}} className="button">
            Zurück
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Success;



// WEBPACK FOOTER //
// ./src/components/questions/Success.js